<glxy-sticky-footer>
  <button mat-flat-button color="primary" (click)="submitClick.emit()" [disabled]="disabled">
    {{ submitOverride || 'AI_ASSISTANT.SHARED.SAVE' | translate }}
  </button>
  @if (!hideCancel && cancelLink) {
    <a mat-stroked-button [routerLink]="[cancelLink]">
      {{ cancelOverride || 'AI_ASSISTANT.SHARED.CANCEL' | translate }}
    </a>
  } @else if (!hideCancel) {
    <button mat-stroked-button (click)="cancelClick.emit()">
      {{ cancelOverride || 'AI_ASSISTANT.SHARED.CANCEL' | translate }}
    </button>
  }
  @if (showUnsavedChangesIndicator) {
    <!-- The nested span here prevents `glxy-sticky-footer` from overriding the styles we get from the class 'unsaved-changes-text' -->
    <span glxyStickyFooterSecondary>
      <span class="unsaved-changes-text">
        {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
      </span>
    </span>
  }
</glxy-sticky-footer>
